<template>
  <div>
    <div>
      <h1 class="text-center">Privileges</h1>
      <div>
        <List />
      </div>
    </div>
  </div>
</template>

<script>
import List from "./ListPrivilege.vue";
export default {
  components: {
    List,
  },
};
</script>
